import { useFacilityModelAccess } from 'features/facilityModel/access'
import { useFimSubject } from 'features/fim'
import { SubjectPhotos } from 'features/fim/photos/SubjectPhotos'
import type { FC } from 'react'

/**
 * The documents-workspace subject panel's Photos section. Renders nothing
 * without Facility Model access or before the subject loads, so the dense
 * panel never shows a dead section.
 */
export const SubjectPanelPhotosSection: FC<{
  siteId: string
  subjectUid: string
}> = ({ siteId, subjectUid }) => {
  const { canView } = useFacilityModelAccess(siteId)
  const { subject } = useFimSubject(siteId, subjectUid, { enabled: canView })

  if (!canView || !subject) return null

  return (
    <SubjectPhotos
      siteId={siteId}
      subject={subject}
      source='subject_panel'
      canEdit={canView}
      layout='strip'
    />
  )
}
